import React from 'react';
import { Modal } from 'react-bootstrap';
import ModalHeader from 'components/Modal/ModalHeader';
import { FieldArray, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import {
  onCancelManageModifierOptions,
  onConfirmManageModifierOptions,
} from 'actions/businessLibrary/modifier';
import ModifierOptionsFieldArray from './ModifierOptionsFieldArray';
import styles from './ModifierOptionsModal.css';

class ModifierOptionsModal extends React.Component {
  render() {
    const { showModifierOptionsModal } = this.props;
    return (
      <Modal
        show={showModifierOptionsModal}
        onHide={this.onCancel}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <ModalHeader title={'Add Option'} />
        <Modal.Body bsClass={`modal-body ${styles.body}`}>
          <FieldArray
            name="modifier_options"
            component={ModifierOptionsFieldArray}
          />
        </Modal.Body>
        <Modal.Footer>
          <span className="pull-left">
            <button className="btn btn-default" onClick={this.onCancel}>
              Cancel
            </button>
          </span>
          <span className="pull-right">
            <button className="btn btn-primary" onClick={this.onSave}>
              Save
            </button>
          </span>
        </Modal.Footer>
      </Modal>
    );
  }

  onCancel = () => {
    const { onCancel, previousModifierForm } = this.props;
    onCancel(previousModifierForm);
  };

  onSave = () => {
    const {
      onConfirm,
      modifier: { modifier_options },
    } = this.props;
    onConfirm(modifier_options);
  };
}

function mapStateToProps(state) {
  const {
    showModifierOptionsModal,
    previousModifierForm,
  } = state.businessLibrary.modifierHub;
  return {
    showModifierOptionsModal,
    previousModifierForm,
    modifier: getFormValues('modifierHub')(state),
  };
}

const mapDispatchToProps = {
  onCancel: onCancelManageModifierOptions,
  onConfirm: onConfirmManageModifierOptions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModifierOptionsModal);
